module.exports = __webpack_public_path__ + "img/art706.a0bf2058.png";